module.exports = __webpack_public_path__ + "static/media/wordpress-social-media-svgrepo-com.9b94ae70.svg";